<template>
  <div>
    <div class="title-level">
      <h1 class="title">Products</h1>
    </div>

    <vs-table striped>
      <template #thead>
        <vs-tr>
          <vs-th sort @click="products = $vs.sortData($event, products, 'name')">Model Number</vs-th>
          <vs-th sort @click="products = $vs.sortData($event, products, 'qty')">QTY</vs-th>
          <vs-th>Action</vs-th>
        </vs-tr>
      </template>

      <template #tbody>
        <vs-tr v-for="product in products" :key="product.id" :data="product">
          <vs-td>{{ product.name }}</vs-td>
          <vs-td>{{ product.qty }}</vs-td>
          <vs-td>
            <router-link :to="{ path: '/details', query: { title: product.title, orders: product.orders }}">View Orders</router-link>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: 'Products',

  data() {
    return {
      products: [],
    };
  },

  created() {
    const orders = this.$store.state.orders;
    const products = [];
    const mergedProducts = [];

    orders.forEach((order) => {
      order.contents.forEach((item) => {
        products.push({
          name: item.name,
          qty: item.qty,
          title: `${item.name} Orders`,
          orders: [order.id],
        });
      });
    });

    products.forEach((product) => {
      const index = mergedProducts.findIndex((mergedProduct) => {
        return mergedProduct.name === product.name;
      });

      if (index >= 0) {
        mergedProducts[index].qty += product.qty;

        product.orders.forEach((order) => {
          if (!mergedProducts[index].orders.includes(order)) {
            mergedProducts[index].orders.push(order);
          }
        });
      } else {
        mergedProducts.push(product);
      }

      this.products = mergedProducts;
    });
  },
};
</script>
